// Ensure URL always reflects current color and size
document.addEventListener("DOMContentLoaded", function () {
  // Wait for all scripts to initialize
  setTimeout(function () {
    // Set up initial URL with current variant
    updateUrlWithCurrentOptions();

    // Watch for all possible change events
    setupChangeListeners();
  }, 500);
});

function setupChangeListeners() {
  // Primary approach: Watch for changes to product variant inputs
  document.addEventListener(
    "change",
    function (e) {
      // Check if this is a product option change
      if (isProductOptionElement(e.target)) {
        // Wait for Shopify to update the variant
        setTimeout(updateUrlWithCurrentOptions, 100);
      }
    },
    true
  );

  // Secondary approach: Watch the URL for variant changes
  let lastVariantId = getCurrentVariantId();
  setInterval(function () {
    const currentVariantId = getCurrentVariantId();
    if (currentVariantId && currentVariantId !== lastVariantId) {
      lastVariantId = currentVariantId;
      updateUrlWithCurrentOptions();
    }
  }, 200);

  // Tertiary approach: Watch for DOM changes to the variant data
  const variantSelects = document.querySelector("variant-selects");
  if (variantSelects) {
    const observer = new MutationObserver(function () {
      updateUrlWithCurrentOptions();
    });

    observer.observe(variantSelects, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  // Watch for any click on swatch elements
  document.addEventListener(
    "click",
    function (e) {
      if (e.target.closest(".product-form__input")) {
        // Wait for the click to process and update variant
        setTimeout(updateUrlWithCurrentOptions, 150);
      }
    },
    true
  );
}

function isProductOptionElement(element) {
  // Check name attribute
  if (
    element.name &&
    (element.name.toLowerCase().includes("option") ||
      element.name.toLowerCase().includes("color") ||
      element.name.toLowerCase().includes("size"))
  ) {
    return true;
  }

  // Check if it's within a product form input
  if (element.closest(".product-form__input")) {
    return true;
  }

  return false;
}

function getCurrentVariantId() {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get("variant");
}

function updateUrlWithCurrentOptions() {
  // Find variant selects component
  const variantSelects = document.querySelector("variant-selects");
  if (!variantSelects) return;

  try {
    // Get the current selected variant data
    const selectedVariantElement = variantSelects.querySelector(
      "[data-selected-variant]"
    );
    if (!selectedVariantElement) return;

    const selectedVariantData = JSON.parse(selectedVariantElement.innerHTML);
    if (!selectedVariantData || !selectedVariantData.id) return;

    const variantId = selectedVariantData.id;

    // Extract options
    let size = "";
    let color = "";

    // Find which option is size and which is color
    const optionElements = variantSelects.querySelectorAll(
      ".product-form__input fieldset legend"
    );

    // Map option names to their values
    for (let i = 0; i < optionElements.length; i++) {
      const optionName = optionElements[i].textContent.trim().toLowerCase();
      const optionPosition = i + 1; // Shopify uses 1-indexed options
      const optionValue = selectedVariantData["option" + optionPosition];

      if (optionName.includes("size")) {
        size = optionValue || "";
      } else if (
        optionName.includes("color") ||
        optionName.includes("colour")
      ) {
        color = optionValue || "";
      }
    }

    // Create URL with current path and all parameters
    const currentPath = window.location.pathname;
    const newUrl = `${currentPath}?variant=${variantId}${
      size ? `&size=${encodeURIComponent(size)}` : ""
    }${color ? `&color=${encodeURIComponent(color)}` : ""}`;

    // Check if URL needs updating
    if (window.location.pathname + window.location.search !== newUrl) {
      // Update URL without page reload
      window.history.replaceState({}, document.title, newUrl);
      console.log(
        "URL updated to match current selection:",
        `variant=${variantId}`,
        size ? `size=${size}` : "",
        color ? `color=${color}` : ""
      );

      // Also update the share button URL if it exists
      const shareButton = document.querySelector("share-button");
      if (shareButton) {
        shareButton.updateUrl(`${window.shopUrl}${newUrl}`);
      }
    }
  } catch (error) {
    console.error("Error updating URL with current options:", error);
  }
}
